export const MAINTENANCE_TICKET = [
  {
    title: 'Quick Submission',
    body: 'Fill out the form below to report any maintenance issues in your apartment or building areas.',
  },
  {
    title: 'Fast Response',
    body: 'We aim to respond to all tickets within 48 hours. Our dedicated team is here to ensure your issues are addressed promptly.',
  },
  {
    title: 'Service Tracking',
    body: 'After submission, you can track the status of your request online at any time.',
  },
];
